export const getMaskedNumber = (number: string) => {
  const last4Digits = number.slice(-3);

  return last4Digits.padStart(number.length, "*");
};
